import { CodeNode } from '@lexical/code';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

import { $createMermaidNode } from './MermaidNode';

export function MermaidPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    const unregister = editor.registerNodeTransform(CodeNode, (node) => {
      const lang = node.getLanguage?.();
      if (lang && lang.toLowerCase() === 'mermaid') {
        const code = node.getTextContent().trim();
        if (code.length === 0) {
          node.remove();
          return;
        }
        node.replace($createMermaidNode(code));
      }
    });

    // Force transforms to run once for initial content (crucial for read-only mode)
    editor.update(() => {});

    return unregister;
  }, [editor]);

  return null;
}
